import React from 'react';
import { AlertTriangle } from 'lucide-react';

const UnavailableWorkspace = ({ title, message }) => (
    <div className="space-y-5">
        <div>
            <p className="text-sm font-semibold uppercase tracking-wide text-amber-700 dark:text-amber-300">
                Unavailable
            </p>
            <h1 className="mt-2 text-3xl font-semibold leading-tight text-slate-950 sm:text-4xl dark:text-white">
                {title}
            </h1>
        </div>

        <div className="rounded-2xl border border-amber-100 bg-amber-50 p-6 text-amber-900 dark:border-amber-400/20 dark:bg-amber-400/10 dark:text-amber-100">
            <div className="flex items-start gap-3">
                <AlertTriangle size={20} className="mt-0.5 flex-shrink-0" />
                <p className="text-sm font-medium leading-relaxed">{message}</p>
            </div>
        </div>
    </div>
);

export default UnavailableWorkspace;
